import { useLang } from '@/i18n';
import EcoSpace from 'eco-design/base/eco-space';
import { useProductStore } from '../../ProductProvider';
import { IPageStatus } from '../../config/IPageStatus';
import BannerA from './components/BannerA';
import BannerB from './components/BannerB';
import CompareA from './components/CompareA';
import EarlyBirdOffer from './components/EarlyBirdOffer';
import FooterTcA from './components/FooterTcA';
import PageNavLeft, { Theme } from './components/PageNavLeft';
import SectionA from './components/SectionA';
import SectionC1 from './components/SectionC1';
import SectionC2 from './components/SectionC2';
import SectionD from './components/SectionD';
import SectionE from './components/SectionE';
import SectionF from './components/SectionF';
import SectionG from './components/SectionG';
import SectionH from './components/SectionH';
import SectionI from './components/SectionI';
import SectionJ from './components/SectionJ';
import SectionK from './components/SectionK';
import SectionL from './components/SectionL';
import SectionM from './components/SectionM';
import SectionN from './components/SectionN';
import WhatInBoxA from './components/WhatInBoxA';

export default function AU_Product() {
    const { t } = useLang('theProduct.KSP');
    const { pageStatus } = useProductStore();
    const IS_Status_A = pageStatus === IPageStatus.statusA;
    const IS_Status_B = pageStatus === IPageStatus.statusB;

    return (
        <div className="glacier-classic">
            {IS_Status_A && <BannerA />}
            {IS_Status_B && <BannerB />}

            <EarlyBirdOffer endTime={new Date('2025/09/30 23:59:59 GMT+8').getTime()} />
            <div className="range1">
                <EcoSpace />
                <SectionA />
            </div>
            <SectionC1 />
            <div className="range2">
                <SectionG />
            </div>
            <SectionH />

            <div className="range3">
                <SectionD />
            </div>
            <div className="range4">
                <SectionE />
            </div>
            <SectionC2 />
            <SectionF />
            <div className="range5">
                <SectionI />
            </div>
            <div className="range6">
                <SectionJ />
                <SectionK />
                <SectionL />
            </div>
            <SectionM />
            <SectionN />
            <CompareA />
            <WhatInBoxA />
            {/* {IS_Status_B && <AccessoryA />} */}
            <FooterTcA />

            {/* 左侧 nav */}
            <PageNavLeft
                triggerElement=".glacier-classic"
                steps={[
                    { text: t('item1'), href: '#SectionA' },
                    { text: t('item2'), href: '#SectionG' },
                    { text: t('item3'), href: '#SectionD' },
                    { text: t('item4'), href: '#SectionE' },
                    { text: t('item5'), href: '#SectionI' },
                    { text: t('item6'), href: '#SectionJ' },
                ]}
                triggerElements={[
                    { selectors: '#SectionA', theme: Theme.black },
                    { selectors: '#SectionB', theme: Theme.black },
                    { selectors: '#sectionC1', theme: Theme.white },
                    { selectors: '#SectionG', theme: Theme.black },
                    { selectors: '#SectionD', theme: Theme.black },
                    { selectors: '#SectionE', theme: Theme.black },
                    { selectors: '#sectionC2', theme: Theme.white },
                    { selectors: '#SectionF', theme: Theme.black },
                    { selectors: '#SectionI', theme: Theme.black },
                    { selectors: '#SectionJ', theme: Theme.white },
                    { selectors: '#SectionL', theme: Theme.white },
                    { selectors: '#sectionM', theme: Theme.black },
                ]}
            />
        </div>
    );
}
